module.exports = __webpack_public_path__ + "static/media/scoreit_large4.1c037071.svg";